import { Component } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FieldType } from '../templates/field.type';
export class FormlyGroup extends FieldType {
/**
 * @return {?}
 */
get newOptions() {
    return { ...this.options };
  }
/**
 * @return {?}
 */
get formlyGroup(): AbstractControl {
    if (this.field.formControl) {
      return this.field.formControl;
    } else {
      return this.form;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-group',
  template: `
    <formly-form [fields]="field.fieldGroup" [model]="model" [form]="formlyGroup" [options]="newOptions" [ngClass]="field.fieldGroupClassName" [buildForm]="false"></formly-form>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyGroup_tsickle_Closure_declarations() {
/** @type {?} */
FormlyGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyGroup.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
